module.exports = __webpack_public_path__ + "static/media/md-attach.fa27bcf0.svg";